import type { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import fetchJson$ from '@atlassian/jira-fetch/src/utils/as-json-stream.tsx';
import type { ReportBean, ReportListBean } from '../../model/types';

export const getReportsForBoard = (baseUrl: string, boardId: number): Observable<ReportBean[]> =>
	// @ts-expect-error - TS2684 - The 'this' context of type 'Observable<unknown>' is not assignable to method's 'this' of type 'Observable<ReportListBean>'. | TS2322 - Type 'Observable<ReportBean>' is not assignable to type 'Observable<ReportBean[]>'.
	fetchJson$(`${baseUrl}/rest/agile/latest/board/${boardId}/reports`).map(
		(response: ReportListBean) => response.reports,
	);
